import { Reveal } from "./Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-40 border-t border-border">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-4">
            <Reveal>
              <span className="font-mono text-xs tracking-[0.35em] text-primary uppercase">01 — Who We Are</span>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <Reveal delay={0.1}>
              <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-6xl leading-[1.05] tracking-tight">
                We turn raw metal into
                <span className="text-primary"> engineered precision</span> — at scale.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-10 text-base lg:text-lg text-muted-foreground leading-relaxed max-w-3xl">
                For over two decades, Techno Stamping &amp; Pressing Industries has been a trusted
                manufacturing partner for demanding OEMs. Our integrated facility combines
                high-tonnage presses, laser fabrication, multi-axis CNC machining and an in-house
                R&amp;D lab — enabling us to take a project from concept and tooling design through
                to validated, high-volume production without ever leaving our floor.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <div className="mt-12 grid sm:grid-cols-3 gap-px bg-border border border-border">
                {[
                  { k: "Integrated", v: "Design to delivery under one roof" },
                  { k: "Certified", v: "ISO 9001:2015 quality systems" },
                  { k: "Trusted", v: "Serving 9+ critical industries" },
                ].map((item, i) => (
                  <div key={i} className="bg-background p-7">
                    <div className="font-display text-xl font-semibold text-primary">{item.k}</div>
                    <div className="mt-2 text-sm text-muted-foreground">{item.v}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
